<template>
  <div class="mc-modal" id="sizesTable" :class="{isOpen: isOpen}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <span class="mc-modal__line"></span>
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            Таблица размеров
          </div>
        </div>
        <div class="mc-modal__body">
          <div class="mc-modal__content">
            <template v-if="true">
              <h3>Как определить свой типовой размер?</h3>
              <p>
              <span>Основные параметры:</span>
<br>

                  <strong>Обхват груди</strong>
                  Для блуз, платьев, жакетов и пальто
                <br>
                  <strong>Обхват талии и бёдер</strong>
                  Для брюк, джинс
                </p>


              <h3>Как измерить свои основные параметры?</h3>
              <p>
                <div class="item">
                  <strong>Обхват груди</strong>
                  Сантиметровая лента проходит по наиболее выступающим точкам груди, далее - под подмышечными впадинами, немного выше по спине.
                </div>
                <div class="item">
                  <strong>Обхват талии</strong>
                  Измеряется строго по линии талии.
                </div>
                <div class="item">
                  <strong>Обхват бедер</strong>
                  Сантиметровая лента проходит по наиболее выступающим точкам ягодиц.
                </div>
              </p>

              <table>
                <caption>
                  Блузки, туники, куртки, платья
                </caption>
                <tr>
                  <th>RU</th>
                  <th>INT</th>
                  <th>Обхват груди,<br> см</th>
                  <th>Обхват талии,<br> см</th>
                  <th>Обхват бедер,<br> см</th>
                  <th>Длина рукава,<br> см</th>
                  <th>Marc Cain</th>
                  <th>GER</th>
                </tr>
                <tr>
                  <td>42</td>
                  <td>S</td>
                  <td>80-83</td>
                  <td>64-67</td>
                  <td>88-91</td>
                  <td>59/61</td>
                  <td>1</td>
                  <td>34</td>
                </tr>
                <tr>
                  <td>44</td>
                  <td>M</td>
                  <td>84-81</td>
                  <td>68-71</td>
                  <td>92-95</td>
                  <td>60/62</td>
                  <td>2</td>
                  <td>36</td>
                </tr>
                <tr>
                  <td>46</td>
                  <td>M</td>
                  <td>88-91</td>
                  <td>72-75</td>
                  <td>96-99</td>
                  <td>60/62</td>
                  <td>3</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>48</td>
                  <td>L</td>
                  <td>92-95</td>
                  <td>76-79</td>
                  <td>100-102</td>
                  <td>60/62</td>
                  <td>4</td>
                  <td>40</td>
                </tr>
                <tr>
                  <td>50</td>
                  <td>L</td>
                  <td>96-99</td>
                  <td>80-83</td>
                  <td>103-105</td>
                  <td>61/63</td>
                  <td>5</td>
                  <td>42</td>
                </tr>
                <tr>
                  <td>52</td>
                  <td>XL</td>
                  <td>100-104</td>
                  <td>84-88</td>
                  <td>106-110</td>
                  <td>61/63</td>
                  <td>6</td>
                  <td>44</td>
                </tr>
                <tr>
                  <td>54</td>
                  <td>XXL</td>
                  <td>105-110</td>
                  <td>89-93</td>
                  <td>111-114</td>
                  <td>31/63</td>
                  <td>7</td>
                  <td>46</td>
                </tr>
              </table>

              <table>
                <caption>
                  Брюки, юбки, шорты, джинсы
                </caption>
                <tr>
                  <th>RU</th>
                  <th>INT</th>
                  <th>Обхват талии,<br> см</th>
                  <th>Обхват бедер,<br> см</th>
                  <th>Marc Cain</th>
                  <th>GER</th>
                </tr>
                <tr>
                  <td>42</td>
                  <td>S</td>
                  <td>64-67</td>
                  <td>88-91</td>
                  <td>1</td>
                  <td>34</td>
                </tr>
                <tr>
                  <td>44</td>
                  <td>M</td>
                  <td>68-71</td>
                  <td>92-95</td>
                  <td>2</td>
                  <td>36</td>
                </tr>
                <tr>
                  <td>46</td>
                  <td>M</td>
                  <td>72-75</td>
                  <td>96-99</td>
                  <td>3</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>48</td>
                  <td>L</td>
                  <td>76-79</td>
                  <td>96-99</td>
                  <td>3</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>50</td>
                  <td>L</td>
                  <td>80-83</td>
                  <td>103-105</td>
                  <td>5</td>
                  <td>42</td>
                </tr>
                <tr>
                  <td>52</td>
                  <td>XL</td>
                  <td>84-88</td>
                  <td>106-110</td>
                  <td>6</td>
                  <td>44</td>
                </tr>
                <tr>
                  <td>54</td>
                  <td>XXL</td>
                  <td>89-93</td>
                  <td>111-114</td>
                  <td>7</td>
                  <td>46</td>
                </tr>
              </table>
            </template>
            <template v-if="false">
            <h3>
              Заголовок
            </h3>
            <p>
              Текст
            </p>
            <h3>
              Заголовок
            </h3>
            <p>
              Текст
            </p>
            <table>
              <caption>
                Блузы, куртки, платья
              </caption>
              <thead>
              <tr>
                <th>
                  RU
                </th>
                <th>
                  INT
                </th>
                <th>
                  Обхват груди, см
                </th>
                <th>
                  Обхват талии, см
                </th>
                <th>
                  Обхват бедер, см
                </th>
                <th>
                  Длина рукава, см
                </th>
                <th>
                  MC
                </th>
                <th>
                  GER
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  54
                </td>
                <td>
                  XXL
                </td>
                <td>
                  105-110
                </td>
                <td>
                  89-93
                </td>
                <td>
                  111-114
                </td>
                <td>
                  31/63
                </td>
                <td>
                  7
                </td>
                <td>
                  46
                </td>
              </tr>
              </tbody>
            </table>
            <table>
              <caption>
                Брюки, юбки, шорты, джинсы
              </caption>
              <thead>
              <tr>
                <th>
                  RU
                </th>
                <th>
                  INT
                </th>
                <th>
                  Обхват груди, см
                </th>
                <th>
                  Обхват талии, см
                </th>
                <th>
                  Обхват бедер, см
                </th>
                <th>
                  Длина рукава, см
                </th>
                <th>
                  MC
                </th>
                <th>
                  GER
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  42
                </td>
                <td>
                  S
                </td>
                <td>
                  80-83
                </td>
                <td>
                  64-67
                </td>
                <td>
                  88-91
                </td>
                <td>
                  59/61
                </td>
                <td>
                  1
                </td>
                <td>
                  34
                </td>
              </tr>
              <tr>
                <td>
                  54
                </td>
                <td>
                  XXL
                </td>
                <td>
                  105-110
                </td>
                <td>
                  89-93
                </td>
                <td>
                  111-114
                </td>
                <td>
                  31/63
                </td>
                <td>
                  7
                </td>
                <td>
                  46
                </td>
              </tr>
              </tbody>
            </table>
            </template>
          </div>
        </div>
  <div class="mc-modal__bottom">
    <button @click="$emit('close')" class="mc-button mc-button--color js-button-close" type="button">
                                                <span class="mc-button__text">
                                                    Закрыть
                                                </span>
    </button>
  </div>
  </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: false
  },
  emits: ['close']
}
</script>

